import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-granite',
  templateUrl: './granite.component.html',
  styleUrls: ['./granite.component.css']
})
export class GraniteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
